// extracted by mini-css-extract-plugin
export var breadcrumb = "_1h-2";
export var breadcrumbArrow = "_1h-3";
export var breadcrumbs = "_1h-0";
export var link = "_1h-4";
export var small = "_1h-1";